import {
  ASYNC_FETCH,
  ASYNC_LOAD,
  ASYNC_FETCH_SUCCESS_ILDDEVICESELECTION,
  ASYNC_FETCH_FAILURE,
  ASYNC_FETCH_INVALIDATE,
  DEVICE_COMPATIBLE_CHECK,
  DEVICE_COMPATIBLE_FLAG,
  UPDATE_SELECTED_LINE_DETAILS,
  CLEAR_ALL_LINES,
  UPDATE_SELECTED_COUNTRY,
  APPLY_ALL_SELECTED_COUNTRY_DETAILS,
  UPDATE_GC_PLAN,
  UPDATED_SUBMITTED_COUNTRIES,
  UPDATE_FRAUD_MODAL_FLAG,
  SET_SELECTED_PLAN,
  UPDATE_COUNTRY_PRICE
} from '../constants';


import { updateObject } from '../../../shared/utilities/reducer';
import common from '../../../shared/utilities/common';

const initialState = {
  isFetching: true,
  statusCode: "",
  statusMessage: "",
  errorMessage: '',
  errorDesc: '',
  actionName: '',
  actionValue: '',
  errorObj: {},
  pageData: "",
  updatedOfferLineDetails: null,
  clearAllLinesFlag: false,
  // addingCountryList: [{}],
  // selectedCountries: {},
  countrySelection: {},
  countrySelectionConfirmed: {},
  countryPrice: 0,
  gcPlan: null,
  isFraudRiskModalShown: false,
  selectedPlan: {},
  loadAPI:true
}


export const asyncFetch = (state, action) => {
  console.log("getSectionsBegin called")
  return updateObject(state, {
    isFetching: true
  });
};

export const asyncLoad = (state, action) => {
  console.log("asyncLoad called")
  return updateObject(state, {
    loadAPI: action.data
  });
};

export const asyncFetchSuccess = (state, action) => {
  return updateObject(state, {
    isFetching: false,
    statusCode: action.msResp.responseInfo.responseCode,
    statusMessage: action.msResp.responseInfo.responseMessage,
    errorMessage: common.isError(action.msResp.responseInfo.responseCode, action.msResp.responseInfo.responseMessage, action.msResp.body),
    errorDesc: common.isErrorDesc(action.msResp.responseInfo.responseCode, action.msResp.responseInfo.responseMessage, action.msResp.body),
    actionName: common.isActionName(action.msResp.responseInfo.responseCode, action.msResp.responseInfo.responseMessage, action.msResp.body),
    actionValue: common.isActionValue(action.msResp.responseInfo.responseCode, action.msResp.responseInfo.responseMessage, action.msResp.body),
    errorObj: action.msResp.responseInfo.responseCode !== "00" && action.msResp.responseInfo ? action.msResp.responseInfo.sectionErrors : null,
    pageData: action.msResp.body,
    loadAPI:false
  });
};

export const asyncFetchFailed = (state, action) => {

  
  let msResp = action && action.err && action.err.response && action.err.response.data;
  let responseCode = msResp && msResp.responseInfo && msResp.responseInfo.responseCode;
  let responseMessage = msResp && msResp.responseInfo && msResp.responseInfo.responseMessage;
  let body = msResp && msResp.body;
  return updateObject(state, {
    isFetching: false,
    pageData: {},
    statusCode: responseCode ? responseCode : '',
    errorMessage: common.isError(responseCode, responseMessage, body),
    errorDesc: common.isErrorDesc(responseCode, responseMessage, body),
    actionName: common.isActionName(responseCode, responseMessage, body),
    actionValue: common.isActionValue(responseCode, responseMessage, body),
    errorObj: responseCode !== "00" && msResp && msResp.responseInfo ? msResp.responseInfo.sectionErrors : action.err,
  });
};


export const setSelectedLineDetailsValue = (state, action) => {
 
  let updatedOfferLineDetails = {};
  const countrySelectionConfirmed = { ...state.countrySelectionConfirmed };
  const countrySelection = { ...state.countrySelection };
  updatedOfferLineDetails = { ...state.updatedOfferLineDetails };
  action.data.forEach((line) => {
    const mtn = Object.keys(line)[0];

    if (line[mtn].offerIdentifier === 'GLOBALCHOICE') {
      // for (const mtnId in countrySelectionConfirmed) {
      //   // countrySelection[mtnId]=countrySelection[mtn]
      // }
    } else if (line[mtn].offerIdentifier !== 'GLOBALCHOICE' || line[mtn].offerId !== 'GLOBALCHOICE') {
      countrySelectionConfirmed[mtn] && delete countrySelectionConfirmed[mtn];  // eslint-disable-line
      countrySelection[mtn] && delete countrySelection[mtn];  // eslint-disable-line
    }

    updatedOfferLineDetails[mtn] = line[mtn];
  });
 
  return updateObject(state, {
    updatedOfferLineDetails: updatedOfferLineDetails,
    countrySelection,
    countrySelectionConfirmed,
  });

};

export const setSelectedPlanValue = (state, action) => {
  return updateObject(state, {
    selectedPlan: action.data
  });
};

const ILDDeviceSelectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SELECTED_LINE_DETAILS: 
      return setSelectedLineDetailsValue(state, action);
    case ASYNC_FETCH:
      return asyncFetch(state, action);
    case ASYNC_LOAD:
      return asyncLoad(state, action); 
    case ASYNC_FETCH_SUCCESS_ILDDEVICESELECTION:
      return asyncFetchSuccess(state, action);
    case ASYNC_FETCH_FAILURE:
      return asyncFetchFailed(state, action);
    // case ASYNC_FETCH_INVALIDATE:
    //   return Object.assign({}, state, { isFetching: false, pageData: {} });
    case UPDATED_SUBMITTED_COUNTRIES: {
        const countrySelectionConfirmed = action.data && { ...action.data };
        return {
          ...state,
          countrySelectionConfirmed,
        };
      }
    case CLEAR_ALL_LINES: {
      let updatedOfferLineDetails = { ...state.updatedOfferLineDetails };
      updatedOfferLineDetails = null;
      const countrySelection = {};
      const countrySelectionConfirmed = {};
      return {
        ...state,
        updatedOfferLineDetails,
        countrySelection,
        countrySelectionConfirmed,
        clearAllLinesFlag: true,
      };
    }
    // case UPDATE_FRAUD_MODAL_FLAG: {
    //   return {
    //     ...state,
    //     isFraudRiskModalShown: true,
    //   };
    // }
    case UPDATE_GC_PLAN: {
      return {
        ...state,
        gcPlan: action.data,
      };
    }

    case UPDATE_COUNTRY_PRICE : {
      const mtn = action.countryData.mtn;
      const countrySelection = { ...state.countrySelection };
      const updatedSelectedCountry = {};
      updatedSelectedCountry.countryPrice = 0;
      countrySelection[mtn] = { ...updatedSelectedCountry };
      return {
        ...state,
        countrySelection,
      };
    }

    case UPDATE_SELECTED_COUNTRY: {
      const mtn = action.countryData.mtn;

      const countrySelection = { ...state.countrySelection };

      const updatedSelectedCountry = {};
      updatedSelectedCountry.addingCountryList = action.countryData.countryList;
      updatedSelectedCountry.selectedCountries = action.countryData.selectedCountries;
      updatedSelectedCountry.countryPrice = (countrySelection[mtn] && countrySelection[mtn].countryPrice && countrySelection[mtn].countryPrice + action.countryData.price) || action.countryData.price;
      countrySelection[mtn] = { ...updatedSelectedCountry };
      return {
        ...state,
        countrySelection,

      };
    }

    case APPLY_ALL_SELECTED_COUNTRY_DETAILS: {
      const selectedMtn = action.data.selectedCountryMtn;
      const countrySelection = { ...state.countrySelection };
      let countrySelectionConfirmed = { ...state.countrySelectionConfirmed };
      const selectedCountries = { ...countrySelection[selectedMtn] };
      const selectedCountriesList = selectedCountries && selectedCountries.selectedCountries && Object.values(selectedCountries.selectedCountries);
      action.data.mtnList.forEach((line) => {
        const mtn = Object.keys(line)[0];
        if (selectedCountriesList != mtn) {
          const updatedCountryDetails = countrySelection[mtn] || {};
          updatedCountryDetails.selectedCountries = selectedCountriesList || action.data.selectedCountries;
          updatedCountryDetails.addingCountryList = (selectedCountries && selectedCountries.addingCountryList) || action.data.onLoadCountries;
          updatedCountryDetails.countryPrice = (selectedCountries && selectedCountries.countryPrice) || action.data.onLoadPrice;
          countrySelection[mtn] = updatedCountryDetails;
        }
      });
      countrySelectionConfirmed = { ...countrySelection };
      return {
        ...state,
        countrySelectionConfirmed,
        countrySelection,
      };
    }
      
    case SET_SELECTED_PLAN:
      return setSelectedPlanValue(state, action);

    default:
      return state;
  }
};

export default ILDDeviceSelectionReducer;
